import React from 'react';
import { Link } from 'react-router-dom';

import FormTitle from 'components/PageLayout/FormTitle';
import { Button } from 'components/curo-components/common/Button';
import { CuroAppRoute } from 'enums/curo/CuroAppRoute';

import styles from './EndPages.module.scss';
import { GO_TO_HOMEPAGE_BUTTON_TEXT } from './constants';

const PAGE_TITLE = 'Loan Funding Unsuccessful.';
const PAGE_DESCRIPTION = (
  <p className={styles.descriptionWrapper}>
    Your loan is approved, but the funding was not successful. One of our team members will contact
    you.
  </p>
);

const FundingFailedPage = () => {
  return (
    <>
      <FormTitle title={PAGE_TITLE} subTitle={PAGE_DESCRIPTION} />
      <Link to={CuroAppRoute.Home}>
        <Button kind="primary" size="form">
          {GO_TO_HOMEPAGE_BUTTON_TEXT}
        </Button>
      </Link>
    </>
  );
};

export default FundingFailedPage;
